import { SavedMessage, Comment, Message } from "../../../../../models";

const getCommentPayload = (response: any): Comment | null => {
    const messageType = response.messageType

    if(messageType !== 0) return null
    
    const comment = JSON.parse(response.commentJson)
    const payload: Comment = {
        commentId: response.commentId,
        tempId: comment.TempId,
        docId: comment.docId,
        userId: comment.userId,
        dateTime: comment.dateTime,
        text: comment.text,
        attachments: comment.attachments
    }
    return payload
}
const getMessagePayload = (response: any): Message | null => {
    const messageType = response.messageType
    
    if(messageType === 0) return null
    
    const payload: Message = {
        chatUId: response.chatMessage.chatUId,
        creationDateTime: response.chatMessage.creationDateTime,
        id: response.chatMessage.id,
        tempId: response.chatMessage.tempId,
        lastModification: response.chatMessage.lastModification,
        messageText: response.chatMessage.messageText,
        replyMessageUid: response.chatMessage.replyMessageUid,
        sender: response.chatMessage.sender,
        attachments: response.chatMessage.attachments
    }
    return payload
}
export const proccessSingleSavedMessageResponse = (response: any): SavedMessage => {
    const messageType = response.messageType

    const comment = getCommentPayload(response)
    const message = getMessagePayload(response)
    const dateTime = response.creationDateTime
    return {
        messageType,
        comment,
        message,
        dateTime
    }
}

export const processSavedMessagesResponse = (savedMessagesResponse: any[]): SavedMessage[] => {    
    return savedMessagesResponse.map(proccessSingleSavedMessageResponse)
}